module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table2"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("表 1-3：音像制品出版情况登记表")]) : _c('span', [_vm._v("表 1-3：电子出版物出版情况登记表")]), _vm._v(" "), _c('div', {
    staticClass: "tabBtns"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.memberEdit(1)
      }
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("返回")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ctrlsLine"
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.tabSeek
    },
    model: {
      value: (_vm.yearSet),
      callback: function($$v) {
        _vm.yearSet = $$v
      },
      expression: "yearSet"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("2017年")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("2018年")])], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.seekPms.keyword),
      callback: function($$v) {
        _vm.$set(_vm.seekPms, "keyword", $$v)
      },
      expression: "seekPms.keyword"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "seekBtn",
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.tabSeek('init')
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    staticClass: "dangerBtns",
    attrs: {
      "size": "small",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.memberDet(1)
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
    staticClass: "dangerBtns",
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": _vm.memberClean
    }
  }, [_vm._v("清除全部")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tabForms"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDat,
      "border": ""
    },
    on: {
      "selection-change": _vm.selectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "45"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "year",
      "label": "年份",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "publicationName",
      "label": "出版物名称",
      "width": "180",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isbn",
      "width": "150",
      "label": "专用书号(ISBN 978-7-)",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "载体形式",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.carrierForm, "C010", _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "出版形式",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.publicationForm, "C011", _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productionUnit",
      "label": "节目来源/制作单位",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "programCapacity",
      "label": "节目时长或容量(分钟/兆)",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "publicationQuantity",
      "label": "出版数量（张/盒）",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "IssueQuantity",
      "label": "发行数量（张/盒）",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unitPrice",
      "label": "发行单价（元）",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "publishingTime",
      "label": "出版时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("stringTrans")(scope.row.publishingTime, "time")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否缴送样本",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.sampleDelivery, "C018", _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否书配盘标记",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.sign, "C018", _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.memberEdit(2, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.memberDet(2, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-360da0c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pressRole/Audio_Electronic/forTabs/table3.vue
// module id = 1710
// module chunks = 1